import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconPrescription } from '@redteclab/icons'

import { useExpaContext } from '../../../../expa'
import { useGlobalConfigContext } from '../../../../global-config'
import { TENANT } from '../../../../tenant'
import {
  urlResolverGetRedeemPaperPrescription,
  urlResolverNfcLandingPage,
} from '../../../../url-handling'
import { HeaderCart } from '../HeaderMiddleSection/HeaderCart'
import { shallShowPrescriptionIcon } from '../HeaderMiddleSection/HeaderMiddleSectionIconsBox'

import { HeaderMobileOpenSearch } from './HeaderMobileOpenSearch'

export const HeaderMobileIconList: FC = () => {
  const publicConfig = useGlobalConfigContext()
  const expa = useExpaContext()

  const { tenant } = publicConfig

  return (
    <ul className="flex items-center gap-2">
      <li className="flex">
        <HeaderMobileOpenSearch />
      </li>
      {shallShowPrescriptionIcon({ expa, tenant }) ? (
        <li>
          <a
            className="flex flex-col items-center"
            href={
              tenant === TENANT.COM
                ? urlResolverNfcLandingPage(publicConfig)
                : urlResolverGetRedeemPaperPrescription(publicConfig)
            }
          >
            <IconPrescription className="text-2xl" />
            <span className="whitespace-nowrap text-xs leading-none">
              <FormattedMessage id="header.icon.receiptText" />
            </span>
          </a>
        </li>
      ) : null}
      <li className="flex">
        <HeaderCart isMobile />
      </li>
    </ul>
  )
}
